import { Redirect } from "../../misc/Redirect";
import { usePhone } from "../../misc/usePhone";
import { useWorkspace } from "../../misc/Workspace";

// TasksHome sends the workspace's tasks to whichever view fits the screen it was
// opened on: the calendar grid needs a week across it, which a phone hasn't got.
export function TasksHome() {
    const phone = usePhone();
    const ws = useWorkspace();

    return <Redirect to={phone ? ws.path("/tasks/day") : ws.path("/tasks/calendar") + "?mode=week"} />;
}
